import type { Dictionary } from './en';

export type Locale = 'en' | 'zh-CN';

export const LOCALES: { value: Locale; label: string; nativeLabel: string }[] = [
  { value: 'en', label: 'English', nativeLabel: 'English' },
  { value: 'zh-CN', label: 'Chinese (Simplified)', nativeLabel: '简体中文' },
];

/** A string that changes shape with a count. */
export type PluralLeaf = { one: string; other: string };

/**
 * Every locale must have exactly the keys English has — a missing one is a
 * compile error, not an empty label discovered by a user.
 *
 * Plural leaves are deliberately loosened to `string | PluralLeaf`: Chinese has
 * no grammatical plural, so forcing `{ one, other }` there would mean writing
 * the same sentence twice and pretending it was a translation decision.
 */
type Leafify<T> = T extends string
  ? string
  : T extends PluralLeaf
    ? string | PluralLeaf
    : { [K in keyof T]: Leafify<T[K]> };

export type LocaleDictionary = Leafify<Dictionary>;

/** Dot-separated paths to every leaf, e.g. `dashboard.availableToReimburse`. */
export type TranslationKey<T = Dictionary, Prefix extends string = ''> = {
  [K in keyof T & string]: T[K] extends string
    ? `${Prefix}${K}`
    : T[K] extends PluralLeaf
      ? `${Prefix}${K}`
      : TranslationKey<T[K], `${Prefix}${K}.`>;
}[keyof T & string];
